import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from 'components/error'
import { RefetchContext } from 'lib/utils/refetchContext'
import ScheduleSegmentControl from 'pages/pga-coach/bookings/schedule/schedule-segment-control'
import EventsPageData from './event-components/events-show-page'
import FreeTierLimitDialog from './free-tier-limit-dialog'
import useStyles from './styles'

const GROUP_EVENT_TIMEFRAME_OPTIONS = [
  {
    value: 'upcoming',
    label: 'Upcoming',
    ariaLabel: 'Upcoming',
    dataTestId: 'group-events-tab-upcoming',
  },
  {
    value: 'past',
    label: 'Past',
    ariaLabel: 'Past',
    dataTestId: 'group-events-tab-past',
  },
]

export const GroupEventsTabs = ({
  selectedTab,
  setSelectedTab,
  showCanceledEvents,
  setShowCanceledEvents,
  inline = false,
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const tabs = (
    <Box className={classes.tabWrapper}>
      <ScheduleSegmentControl
        value={selectedTab}
        onChange={(_, newValue) => {
          if (newValue !== null) setSelectedTab(newValue)
        }}
        options={GROUP_EVENT_TIMEFRAME_OPTIONS}
        ariaLabel="Group events timeframe"
        isMobile={isMobile}
      />
      <Box>
        <FormControlLabel
          className={classes.showCancellations}
          size="size"
          control={
            <Switch
              checked={showCanceledEvents}
              onChange={e => setShowCanceledEvents(e.target.checked)}
            />
          }
          label={<Typography variant="button">Show Cancellations</Typography>}
        />
      </Box>
    </Box>
  )

  if (inline) {
    return tabs
  }

  return <Container className={classes.containerStyles}>{tabs}</Container>
}

const GroupEventsPanel = ({ panel, showInlineTabs = false }) => {
  const {
    selectedTab,
    setSelectedTab,
    showCanceledEvents,
    setShowCanceledEvents,
    offset,
    setOffset,
    showLimitReachedDisclaimer,
    setShowLimitReachedDisclaimer,
    openFreeTierLimitDialog,
    setOpenFreeTierLimitDialog,
    isPgaHopeCoach,
    setIsPgaHopeCoach,
    data,
    loading,
    error,
    refetch,
  } = panel

  return (
    <>
      {showInlineTabs ? (
        <GroupEventsTabs
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          showCanceledEvents={showCanceledEvents}
          setShowCanceledEvents={setShowCanceledEvents}
          inline
        />
      ) : null}
      {loading && <LinearProgress color="primary" />}
      {error && <Error />}
      {!loading && !error && (
        <RefetchContext.Provider value={refetch}>
          <EventsPageData
            eventsData={data}
            selectedTab={selectedTab}
            showCanceledEvents={showCanceledEvents}
            offset={offset}
            setOffset={setOffset}
            showLimitReachedDisclaimer={showLimitReachedDisclaimer}
            setShowLimitReachedDisclaimer={setShowLimitReachedDisclaimer}
            setIsPgaHopeCoach={setIsPgaHopeCoach}
          />
          <FreeTierLimitDialog
            open={openFreeTierLimitDialog}
            setOpen={setOpenFreeTierLimitDialog}
            isPgaHopeCoach={isPgaHopeCoach}
          />
        </RefetchContext.Provider>
      )}
    </>
  )
}

export default GroupEventsPanel
